import { Flex, SpinnerProps } from '@chakra-ui/react'
import React, { useMemo } from 'react'

export const FullscreenWrapper: React.FC<FullScreenLoaderRoundProps> = ({
  loading = true,
  opacity = 0,
  ...props
}) => {
  const before = useMemo(
    () => ({
      background: 'white',
      bottom: 0,
      content: '""',
      left: 0,
      opacity,
      position: 'absolute',
      right: 0,
      top: 0,
    }),
    [opacity],
  )
  return (
    <Flex
      _before={before}
      alignItems="center"
      display="flex"
      height="100vh"
      justifyContent="center"
      left={loading ? 0 : '-99999px'}
      opacity={loading ? 1 : 0}
      position="fixed"
      top={0}
      visibility={loading ? 'visible' : 'hidden'}
      width="100%"
      zIndex={10000}
      {...props}
    />
  )
}

export interface FullScreenLoaderProps extends SpinnerProps {
  loading?: boolean
  opacity?: number
}

export interface FullScreenLoaderRoundProps
  extends Omit<SpinnerProps, 'thickness'> {
  loading?: boolean
  opacity?: number
  thickness?: number
}
